module.exports = (theme) => ({
  ".faq": {
    maxWidth: "785px",
    marginTop: theme("spacing.4xl"),
    marginBottom: theme("spacing.4xl"),
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "21px",
    paddingRight: "21px",
  },
  ".faq-container": {
    maxWidth: "743px",
  },
  ".faq-heading": {
    paddingBottom: theme("spacing.DEFAULT"),
  },
  ".faq-container details": {
    "@apply ds-border-tertiary-lightgrey ds-border-b": true,
    paddingTop: theme("spacing.DEFAULT"),
    paddingBottom: theme("spacing.DEFAULT"),
  },
  ".faq-container summary": {
    fontSize: theme("fontSize.xl"),
    lineHeight: theme("lineHeight.base"),
  },
  ".faq-container p": {
    lineHeight: theme("lineHeight.base"),
    paddingTop: theme("spacing.xs"),
    paddingBottom: theme("spacing.sm"),
  },

  ".faq-container ul": {
    listStyle: "none",
    paddingLeft: "20px",
    marginTop: theme("spacing.DEFAULT"),
    marginBottom: theme("spacing.DEFAULT"),
  },

  ".faq-container ul li": {
    paddingLeft: theme("spacing.sm"),
    lineHeight: theme("lineHeight.base"),
  },

  ".faq-container ul li::before": {
    backgroundColor: theme("colors.primary.blue.DEFAULT"),
    borderRadius: "3px",
    display: "inline-block",
    marginRight: theme("spacing.sm"),
    padding: "3px",
    verticalAlign: "middle",
    content: '""',
    listStyle: "none",
    marginLeft: "-18px",
  },

  ".faq-container ol": {
    listStyle: "decimal",
    paddingLeft: theme("fontSize.xl"),
    marginTop: theme("spacing.DEFAULT"),
    marginBottom: theme("spacing.DEFAULT"),
  },

  ".faq-container ol li": {
    padding: "0",
    paddingLeft: theme("spacing.sm"),
  },

  ".faq-container ul[style*='list-style-type: check-mark;'] li": {
    listStyle: "none",
    paddingLeft: theme("spacing.sm"),
  },

  ".faq-container ul[style*='list-style-type: check-mark;'] li::before": {
    backgroundColor: "inherit",
    padding: "0",
    fontFamily: '"Vattenfall Elements Icons", "Vattenfall Icons"',
    content: '"\\e97f"',
    marginRight: theme("spacing.sm"),
    marginLeft: "-34px",
    fontSize: theme("fontSize.2xl"),
    verticalAlign: "bottom",
  },

  [`@media (max-width: ${theme("screens.xs")})`]: {
    ".faq-container summary": {
      fontSize: theme("fontSize.lg"),
    },
  },
});
